import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import React, { FC, ReactElement } from 'react';
import { Paper } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { ProductAvailabilityChange } from '../../services/warehouse';
import { Product } from '../../services/typings';
import { HtmlTooltip, useStyles } from './styles';
import WarehouseItemTooltip from '../WarehouseItemTooltip';

export interface Props {
  name: string;
  search: string;
  products: Product[];
  productAvailabilityChanges: ProductAvailabilityChange[];
  index: number;
  addCart(id: number): void;
  changeProductOrderAvailability(product_id: number): void;
}

const ProductCategory: FC<Props> = ({
  name,
  products,
  search,
  addCart,
  index,
}: Props): ReactElement | null => {
  const classes = useStyles({ index });
  const filteredProducts = products.filter((product): boolean =>
    product.name.toLowerCase().includes(search.toLowerCase()),
  );
  if (isEmpty(filteredProducts)) return null;

  return (
    <Paper elevation={4} className={classes.wrapper}>
      <h3 className={classes.categoryTitle}>{name}</h3>

      <div className={classes.buttonContainer}>
        {filteredProducts.map(product => (
          <HtmlTooltip key={product.id} title={<WarehouseItemTooltip product={product} />} arrow>
            <Button
              key={product.id}
              className={clsx(classes.button, classes.buttonColor)}
              color="primary"
              onClick={(): void => addCart(product.id)}
            >
              {product.name}
            </Button>
          </HtmlTooltip>
        ))}
      </div>
    </Paper>
  );
};

export default ProductCategory;
